<div class="image-picker-container">
    <img [src]="imageSource" class="image-picker-preview">
    <div class="image-picker-button-container" (click)="openDialog()">
        <mat-icon>photo_camera</mat-icon>
    </div>
</div>